import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GlobalService } from './global.service';
import { NotaFiscal } from './../models/nota-fiscal';

@Injectable({
  providedIn: 'root'
})
export class NotaFiscalService {
  constructor(private globalService: GlobalService, private http: HttpClient) {}

  possuiNota(idCupom, tipo) {
    return this.http.get<any>(globals.apiUrl + '/api/NotaFiscal/PossuiNota',
      { params: new HttpParams().set('idCupom', idCupom).set('tipo', tipo) });
  }

  buscarNota(chave) {
    return this.http.get<NotaFiscal>(globals.apiUrl + '/api/NotaFiscal/BuscarNota',
      { params: new HttpParams().set('chave', chave) });
  }

  imprimirNotaPorIdCupom(idCupom, tipo) {
    let parametros = new HttpParams().set('idCupom', idCupom).set('tipo', tipo);

    return this.http.get(globals.apiUrl + '/api/NotaFiscal/ImprimirNotaPorIdCupom',
      { params: parametros, responseType: 'blob' });
  }

  imprimirNotaPorNNota(nNota) {
    let parametros = new HttpParams().set('nNota', nNota);

    return this.http.get(globals.apiUrl + '/api/NotaFiscal/ImprimirNotaPorNNota',
      { params: parametros, responseType: 'blob' });
  }

  buscarNotasDoPedido(idCupom, filtraOcorrencia) {
    let parametros = new HttpParams().set('idCupom', idCupom);

    if (filtraOcorrencia != null && filtraOcorrencia != undefined) {
      parametros = parametros.set('filtraOcorrencia', filtraOcorrencia);
    }

    return this.http.get<NotaFiscal[]>(globals.apiUrl + '/api/NotaFiscal/BuscarNotasDoPedido',
      { params: parametros });
  }

  salvar(notaFiscal) {
    return this.http.post(globals.apiUrl + '/api/NotaFiscal/Salvar', notaFiscal);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/NotaFiscal/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  baixarXML(id) {
    return this.http.get(globals.apiUrl + '/api/NotaFiscal/BaixarArquivo',
      { params: new HttpParams().set('id', id), responseType: 'blob' });
  }
}
